import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { Can } from '../utils/ability-context';

import isAuthenticated from '../utils/session';

const renderRoute = (Component, rest) => (
  <Route
    {...rest}
    render={props =>
      (isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      ))
    }
  />
);

const PrivateRoute = ({ component: Component, can, on, ...rest }) => {
  if (!can || !on) return renderRoute(Component, rest);
  return (
    <Can I={can} a={on} passThrough>
      {permited => (permited ?
        renderRoute(Component, rest) :
        <Redirect
          to={{
            pathname: '/not_found',
          }}
        />)}
    </Can>
  );
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  can: PropTypes.string,
  on: PropTypes.string,
};

PrivateRoute.defaultProps = {
  location: null,
  can: '',
  on: '',
};



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js